export type Language = 'fr' | 'en'

export const translations = {
  nav: {
    fr: {
      home: 'Accueil',
      sessions: 'Séances',
      retreats: 'Retraites',
      contact: 'Contact',
    },
    en: {
      home: 'Home',
      sessions: 'Sessions',
      retreats: 'Retreats',
      contact: 'Contact',
    },
  },
  home: {
    fr: {
      titles: [
        'Thérapeute',
        'Conseillère Conjugale',
        'Facilitatrice de Groupes',
        'Fondatrice de Nexus Dance',
        'Organisatrice de Retraites',
      ],
      introTitle: 'Une Approche Holistique',
      introText:
        "À travers une écoute profonde du corps et de l'esprit, je vous accompagne sur le chemin de la guérison et de la reconnexion à vous-même. Mon approche intègre la thérapie par la parole, le travail somatique et le mouvement pour libérer les blocages et éveiller votre vitalité.",
      cta: 'Réserver une séance',
      aboutTitle: 'À Propos de Juliette',
      bio: [
        "Juliette est une âme d'origine française, mère et femme d'affaires qui a fait de la Nouvelle-Zélande son foyer depuis plus d'une décennie. Au-delà de ses fondations cliniques en psychologie acquises en Europe, son parcours a été façonné par une expérience vécue de transitions culturelles, d'identités en évolution et de processus de renaissance.",
        "Animée d'une passion profonde pour la guérison holistique, elle a consacré sa vie à guider les autres sur leur chemin de découverte de soi et de transformation.",
        "Puisant dans des années d'expérience et une connexion profonde à la sagesse du corps, Juliette offre un mélange unique de douceur et de clarté qui permet aux individus et aux couples de traverser les défis de la vie avec grâce et résilience.",
      ],
      nexusParagraph:
        "Juliette est également la fondatrice de Nexus Dance School, où elle crée des espaces sécurisants pour que les gens se connectent à leur corps et à leur partenaire à travers la danse. Elle anime des ateliers et des retraites transformationnelles pour les femmes et les couples. Elle facilite également des cercles thérapeutiques mensuels à l'Alliance Française.",
      visitNexus: 'Visiter le site Nexus',
      explorePastRetreats: 'Explorer les Retraites',
      testimonialsTitle: 'Témoignages',
      testimonials: [
        {
          quote:
            "Juliette m'a accompagnée dans mes moments de doute mais aussi de joie. C'est un être de lumière, doux et spirituel, qui vous guidera et vous soutiendra sur votre chemin. Je la recommande de tout mon cœur.",
          name: 'Chris',
        },
        {
          quote:
            "Ceux d'entre vous qui ne la connaissent pas encore, vous allez vouloir la connaître. Honnêtement, c'est l'être de lumière le plus rayonnant que j'aie jamais rencontré. Pleine d'amour et de compassion, mais si claire qu'une seule de ses phrases peut changer votre vie pour toujours.",
          name: 'Caroline',
        },
        {
          quote:
            "Ce n'est pas une thérapeute ordinaire. C'est plutôt le genre de personne qui travaille avec son cœur, qui vous prend par la main et vous ramène sur le chemin de votre vie. Je la recommande vivement à ceux qui veulent se recentrer et avancer.",
          name: 'Maria',
        },
      ],
    },
    en: {
      titles: [
        'Integrative Therapist',
        'Relationship Counsellor',
        'Workshop Facilitator',
        'Founder of Nexus Dance',
        'Retreat Organiser',
      ],
      introTitle: 'A Holistic Approach',
      introText:
        'Through deep listening to the body and mind, I guide you on the path of healing and reconnection to yourself. My approach integrates talk therapy and somatic work. Together, we illuminate what is unseen, translating energy into language to release deep blockages and reawaken your essence.',
      cta: 'Book a session',
      aboutTitle: 'About Juliette',
      bio: [
        'Juliette is a French-born soul, mother, and businesswoman who has called New Zealand home for over a decade. Beyond her clinical foundations in psychology from Europe, her path has been shaped by a lived experience of cultural shifts, evolving identities, and processes of rebirth.',
        'With a deep passion for holistic healing, she has dedicated her life to guiding others on their journey of self-discovery and transformation.',
        "Drawing from years of experience and a profound connection to the body's wisdom, Juliette offers a unique blend of gentleness and clarity that empowers individuals and couples to move through life's challenges with grace and resilience.",
      ],
      nexusParagraph:
        "Juliette is also the founder of Nexus Dance School, where she creates safe spaces for people to connect with their bodies and their partners through dance. She facilitates workshops and transformational retreats for both women and couples. Additionally, she facilitates monthly therapeutic circles at l'Alliance Française.",
      visitNexus: 'Visit Nexus Website',
      explorePastRetreats: 'Explore Past Retreats',
      testimonialsTitle: 'Testimonials',
      testimonials: [
        {
          quote:
            'Juliette accompanied me in my moments of doubt but also of joy. She is a gentle and spiritual being of light who will guide and support you on your path. I recommend her with all my heart.',
          name: 'Chris',
        },
        {
          quote:
            "Those of you who don't yet know her, you will want to. Honestly, she is the most radiant light being I have ever met. Full of love and compassion, yet so clear that even one sentence from her can change your life forever.",
          name: 'Caroline',
        },
        {
          quote:
            "She's not an ordinary therapist. She's more the kind of person who works with her heart, who takes you by the hand and leads you back on the path of your life. I strongly recommend her to people who want to refocus and move forward.",
          name: 'Maria',
        },
      ],
    },
  },
  services: {
    fr: {
      pageTitle: 'Séances',
      learnMore: 'En savoir plus',
      services: [
        {
          id: 1,
          title: 'Séance Individuelle',
          price: '$170',
          duration: '1 Heure',
          desc: "Un espace sécurisant pour explorer vos émotions, schémas et blocages à travers la thérapie par la parole et l'écoute somatique.",
        },
        {
          id: 2,
          title: 'Séance de Couple',
          price: '$200',
          duration: '1 Heure',
          desc: "Restaurer la communication, raviver l'intimité et transformer les conflits en opportunités de croissance mutuelle.",
        },
        {
          id: 3,
          title: 'Relationship Rescue',
          price: '$300',
          duration: '2 Heures',
          desc: 'Une session approfondie pour les couples traversant une crise aiguë, nécessitant une intervention immédiate et un espace de médiation sécurisé.',
        },
        {
          id: 4,
          title: 'Intensive Demi-journée',
          price: '$400',
          duration: '4 Heures',
          desc: 'Une plongée profonde dans votre processus de guérison. Idéal pour dénouer des traumas complexes ou initier un changement majeur dans votre vie.',
        },
      ],
    },
    en: {
      pageTitle: 'Sessions',
      learnMore: 'Learn more',
      services: [
        {
          id: 1,
          title: 'Individual Session',
          price: '$170',
          duration: '1 Hour',
          desc: "A safe therapeutic support through different stages of client's life path.\n\nDoubts, fears, stress, pregnancy, grief, break up, illness...\n\nIt aims to give clients the tools to harness the resources they already have within them.\n\nBased on introspection, the analysis of problematic situations and the exploration of feelings and emotions, these sessions aim to advance, facilitate the client's reflection, help them see things more clearly and to promote awareness.\n\nIn addition to listening and support, these sessions brings a opportunity to take a break, a time for oneself to breathe and recharge.",
        },
        {
          id: 2,
          title: 'Couples Session',
          price: '$200',
          duration: '1 Hour',
          desc: 'The human being evolves and the relationships are often impacted as well.\nThese sessions support couples on the path of life together.\n\nOffering a neutral and benevolent space where everyone can feel free to come and leave what they have to say.\n\nTogether we work on the needs and the place of each individual, in order to find harmony within the couple, then within the family.',
        },
        {
          id: 3,
          title: 'Relationship Rescue',
          price: '$300',
          duration: '2 Hours',
          desc: "Two Hours to Find Your Way Back to Each Other\n\nEvery couple faces moments when the distance feels big, the conflict too heavy, or the words too hard to find.\n\nA Relationship Rescue Session offers a safe, guided space to pause, breathe, and reconnect — before decisions are made that cannot be undone.\n\nIn this two-hour intensive, we focus on the heart of the crisis. Together, we untangle what's really happening beneath the surface, open the door to honest communication, and explore practical ways forward that feel respectful to both of you.\n\nWhether you're facing a rupture or a long-standing struggle, this is a space where you can both be heard — and where new possibilities can begin.",
        },
        {
          id: 4,
          title: 'Half-Day Intensive',
          price: '$400',
          duration: '4 Hours',
          desc: "Focused, Personalized Support\n\nThis session tailored to your unique needs, whether you're coming as an individual, a couple, part of a family, or an organisation.\n\nIt's designed for those facing a specific challenge or simply wanting to explore their inner world and personal growth.\n\nI'm here to listen, sense what's going on beneath the surface, and guide our time together in the way that feels most helpful.\n\nI tune into the situation, perceive the limitations, and adapt the session to explore and work through what needs attention.\n\nThink of it as a powerful breakthrough session, a concentrated, transformative boost that can unlock new perspectives and shift energy.\n\nWhile follow-up sessions are available, there is no obligation or commitment afterward.\n\nThis space is yours. An invitation to slow down, dive deep, and come away feeling lighter, clearer, and more connected to yourself.",
        },
      ],
    },
  },
  retreats: {
    fr: {
      sense: {
        title: 'Sense & Sensuality',
        subtitle: 'Kawau Island, New Zealand',
        aboutTitle: "À propos de l'événement",
        aboutText:
          "Une retraite immersive conçue pour éveiller vos sens et vous reconnecter à votre sensualité innée. Dans le cadre idyllique de Kawau Island, loin du tumulte du quotidien, nous explorerons les profondeurs de l'expression corporelle.",
        bullets: [
          'Pratiques somatiques quotidiennes',
          'Danse intuitive et mouvement libre',
          'Cercles de parole et rituels',
          'Nourriture saine et hébergement de luxe',
        ],
      },
      lilithisis: {
        title: 'Lilithisis',
        subtitle: "Éveil de l'Énergie Féminine",
        aboutText:
          'Un voyage initiatique au cœur de votre puissance féminine. Lilithisis est une invitation à embrasser toutes les facettes de votre être, de la plus lumineuse à la plus sauvage, dans un espace sacré de sororité.',
      },
      custom: {
        title: 'Retraite Personnalisée',
        aboutText:
          "Vous ressentez le besoin d'une retraite sur-mesure, seul(e) ou avec un groupe privé ? Je crée des expériences uniques adaptées à vos intentions spécifiques, vos besoins de guérison et vos désirs d'évolution. De la sélection du lieu au programme quotidien, chaque détail est pensé pour vous.",
        cta: 'Créer votre retraite',
      },
      discoverCta: 'Découvrir',
    },
    en: {
      sense: {
        title: 'Sense & Sensuality',
        subtitle: 'Kawau Island, New Zealand',
        aboutTitle: 'About the event',
        aboutText:
          'An immersive retreat designed to awaken your senses and reconnect you to your innate sensuality. In the idyllic setting of Kawau Island, far from the hustle and bustle of daily life, we will explore the depths of bodily expression.',
        bullets: [
          'Daily somatic practices',
          'Intuitive dance and free movement',
          'Talking circles and rituals',
          'Healthy food and luxury accommodation',
        ],
      },
      lilithisis: {
        title: 'Lilithisis',
        subtitle: 'Awakening Feminine Energy',
        aboutText:
          'An initiatory journey to the heart of your feminine power. Lilithisis is an invitation to embrace all facets of your being, from the brightest to the wildest, in a sacred space of sisterhood.',
      },
      custom: {
        title: 'Personalised Retreat',
        aboutText:
          'Do you feel the need for a bespoke retreat, alone or with a private group? I create unique experiences tailored to your specific intentions, healing needs, and desires for evolution. From selecting the location to the daily program, every detail is designed for you.',
        cta: 'Create your retreat',
      },
      discoverCta: 'Discover',
    },
  },
  contact: {
    fr: {
      title: 'Contact',
      cabinet: 'Séances en Présentiel',
      online: 'Séances en Ligne',
      home: 'Visites à Domicile (+10$)',
      locations: {
        vp: {
          name: 'Victoria Park',
          address: '123 Wellness Ave, Auckland CBD',
        },
        epsom: { name: 'Epsom', address: '45 Healing Way, Epsom' },
      },
    },
    en: {
      title: 'Contact',
      cabinet: 'In-Person Sessions',
      online: 'Online Sessions',
      home: 'Home Visits (+$10)',
      locations: {
        vp: {
          name: 'Victoria Park',
          address: '123 Wellness Ave, Auckland CBD',
        },
        epsom: { name: 'Epsom', address: '45 Healing Way, Epsom' },
      },
    },
  },
}
